module.exports = __webpack_public_path__ + "img/vip_wechat_default.ef3210ab.svg";